"use strict";

import React from 'react';

function Icon( {name='', className='', style={}} ){
    if(!!name){
        return (
            <i className={`icon-${name} ${className}`} style={style} />
        );
    }
    return null;
}

export default Icon
